<template>
    <basic-container>
        <avue-crud :option="option"
                   :table-loading="loading"
                   :data="data"
                   :page="page"
                   :permission="permissionList"
                   :before-open="beforeOpen"
                   v-model="form"
                   ref="crud"
                   @row-update="rowUpdate"
                   @row-save="rowSave"
                   @row-del="rowDel"
                   @search-change="searchChange"
                   @search-reset="searchReset"
                   @selection-change="selectionChange"
                   @current-change="currentChange"
                   @size-change="sizeChange"
                   @refresh-change="onLoad"
                   @on-load="onLoad">
            <template slot="menu" slot-scope="scope">
              <el-button
                  type="text"
                  size="small"
                  icon="el-icon-delete"
                  v-if="scope.row.finishStatus === 0"
                  @click="handleDelete(scope.row.id)"
                >删除
              </el-button>
            </template>
        </avue-crud>
    </basic-container>
</template>

<script>
    import {add, getDetail, getList, remove, update} from "@/api/v4ward/property/basepropertybill";
    import {mapGetters} from "vuex";

    export default {
        data() {
            return {
                form: {
                  billEndTime: '',
                },
                query: {},
                loading: true,
                page: {
                    pageSize: 10,
                    currentPage: 1,
                    total: 0
                },
                selectionList: [],
                option: {
                    height: 'auto',
                    calcHeight: 'auto',
                    tip: false,
                    searchShow: true,
                    searchMenuSpan: 18,
                    border: true,
                    labelWidth: '130',
                    index: true,
                    viewBtn: false,
                    editBtn: false,
                    delBtn: false,
                    selection: false,
                    dialogClickModal: false,
                    indexLabel: "序号",
                    column: [
                      {
                        label: '小区名称',
                        prop: 'communityId',
                        hide: false,
                        viewDisplay: false,
                        editDisplay: false,
                        search: true,
                        type: 'tree',
                        rules: [
                          {
                            required: true,
                            message: '请选择小区名称',
                            trigger: 'change',
                          },
                        ],
                        props: {
                          label: 'title',
                          value: 'id',
                        },
                        dicUrl: '/api/base/property/tree1?objectTypeKey=1',
                      },
                          {
                            label: '费用类型',
                            prop: 'feeSort',
                            addDisplay: false,
                            props: {
                              label: 'dictValue',
                              value: 'dictKey',
                            },
                            dicUrl: '/api/blade-system/dict/dictionary?code=fee_sort',
                            dataType: 'number',
                          },
                      {
                        label: '账单截至日期',
                        prop: 'billEndTime',
                        type: 'month',
                        format: 'yyyy-MM',
                        rules: [
                          {
                            required: true,
                            message: '账单截至日期',
                            trigger: 'blur',
                          },
                        ],
                      },
                          {
                            label: "提交人",
                            prop: "submitName",
                            addDisplay:false,
                          },
                          {
                            label: "提交时间",
                            prop: "submitTime",
                            addDisplay:false,
                          },
                         {
                            label: "状态",
                            prop: "finishStatus",
                            addDisplay:false,
                            dicData: [{ name: '未完成', finishStatus: 0 }, { name: '已完成', finishStatus: 1 }],
                            props: {
                             value: 'finishStatus',
                             label: 'name',
                           },
                          },
                         {
                            label: "生成账单时间",
                            prop: "billingTime",
                            addDisplay:false,
                          },
                    ]
                },
                data: []
            };
        },
        computed: {
            ...mapGetters(["permission"]),
            permissionList() {
                return {
                    addBtn: this.vaildData(this.permission.basepropertybill_add, true),
                    viewBtn: this.vaildData(this.permission.basepropertybill_view, false),
                    delBtn: this.vaildData(this.permission.basepropertybill_delete, false),
                    editBtn: this.vaildData(this.permission.basepropertybill_edit, false)
                };
            },
            ids() {
                let ids = [];

                this.selectionList.forEach(ele => {
                    ids.push(ele.id);
                });
                return ids.join(",");
            }
        },
      mounted(){
        this.option.height = this.bodyHeight - 335;
        window.onresize = ()=>{
          this.$refs.crud.$refs.table.doLayout()
        };
        this.$refs.crud.$refs.table.doLayout()
      },
      watch:{
        '$route.path':function(newVal,oldVal){
          // console.log(newVal + '---' +  oldVal);
          if(newVal === '/v4ward/property/basepropertybill'){
            this.$refs.crud.$refs.table.doLayout()
          }
        }
      },
        methods: {
            rowSave(row, done, loading) {
              console.log("form>>>>>>>",this.form);
              row.billEndTime = this.dayjs(row.billEndTime).format("YYYY-MM")
                add(row).then(() => {
                    this.onLoad();
                    this.$message.success('申请已提交,当天晚上进行系统开账！');
                    done();
                }, error => {
                    window.console.log(error);
                    loading();
                });
            },
            rowUpdate(row, index, done, loading) {
                update(row).then(() => {
                    this.onLoad();
                    this.$message.success('操作成功!');
                    done();
                }, error => {
                    window.console.log(error);
                    loading();
                });
            },
            rowDel(row) {
                this.$confirm("确定将选择数据删除?", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        return remove({ids: row.id});
                    })
                    .then(() => {
                        this.onLoad();
                        this.$message.success('操作成功!');
                    });
            },
            handleDelete(id) {
                // if (this.selectionList.length === 0) {
                //     this.$message.warning("请选择至少一条数据");
                //     return;
                // }
                this.$confirm("确定将选择数据删除?", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        return remove({ids: id});
                    })
                    .then(() => {
                        this.onLoad();
                        this.$message.success('操作成功!');
                        this.$refs.crud.toggleSelection();
                    });
            },
            beforeOpen(done, type) {
                if (["edit", "view"].includes(type)) {
                    getDetail({id:this.form.id}).then(({data}) => {
                        this.form = data;
                    });
                }
                done();
            },
            searchReset() {
                this.query = {};
                this.onLoad();
            },
            searchChange(params, done) {
                this.query = params;
                this.page.currentPage = 1;
                this.onLoad();
                done();
            },
            selectionChange(list) {
                this.selectionList = list;
            },
            selectionClear() {
                this.selectionList = [];
                this.$refs.crud.toggleSelection();
            },
            currentChange(currentPage) {
                this.page.currentPage = currentPage;
            },
            sizeChange(pageSize) {
                this.page.pageSize = pageSize;
            },
            onLoad(page) {
                page = page || this.page;
                this.loading = true;
                getList(
                    Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
                ).then(({data}) => {
                    this.page.total = data.total;
                    this.data = data.records;
                    this.loading = false;
                    this.selectionClear();
                });
            }
        }
    };
</script>

<style scoped>
  ::v-deep .avue-form__menu--center{
    text-align: right;
  }
  ::v-deep .avue-crud__search .el-form-item--small.el-form-item{
    width: 100%;
  }
</style>
